// extracted by css-extract-rspack-plugin
export default {"selectIcon":"src-wab-client-components-sidebar-tabs-ListStyleSection-module__selectIcon-PMq9nj"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"selectIcon\":\"src-wab-client-components-sidebar-tabs-ListStyleSection-module__selectIcon-PMq9nj\"}";
        // 1793541991587
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  